import styled, { keyframes } from 'styled-components';

const barAnimation = keyframes`
  0%, 40%, 100% {
    transform: scaleY(0.4);
    -webkit-transform: scaleY(0.4);
  }  20% {
    transform: scaleY(1.0);
    -webkit-transform: scaleY(1.0);
  }
`;

const StyledSpinner = styled.div`
    width: 50px;
    height: 40px;
    text-align: center;
    font-size: 10px;
`;

const SpinnerInternalBar = styled.div<{ color?: string }>`
    background: ${(props) => (props.color ?? '#FF609E')};
    height: 100%;
    width: 4px;
    display: inline-block;
    border-radius: 40px;
    margin: 0 1px;
    animation: ${barAnimation} 1.2s infinite ease-in-out;
`;

const SpinnerBar2 = styled(SpinnerInternalBar)`
    animation-delay: -1.1s;
    background: ${(props) => (props.color ?? '#FF609E')};
`;

const SpinnerBar3 = styled(SpinnerInternalBar)`
    animation-delay: -1s;
    background: ${(props) => (props.color ?? '#FF609E')};
`;

const SpinnerBar4 = styled(SpinnerInternalBar)`
    animation-delay: -0.9s;
    background: ${(props) => (props.color ?? '#FF609E')};
`;

const SpinnerBar5 = styled(SpinnerInternalBar)`
    animation-delay: -0.8s;
    background: ${(props) => (props.color ?? '#FF609E')};
`;

export default { barAnimation, StyledSpinner, SpinnerBar2, SpinnerBar3, SpinnerBar4, SpinnerBar5, SpinnerInternalBar };
